






































































































































import { Component, Mixins } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import { VoiceMailModel } from "../models/VoiceMailModel";
import Filters from "@/common/Filters";
import VoiceMailFilter from "@/models/VoiceMailFilterModel";
import TwilioService from "@/services/twilio.service";
import Shared from "../common/shared";

@Component({
  filters: {
    dateTimeFormat: Filters.formatDateTime,
    hourMinuteFormat: Filters.formatHourMinute,
  },
})
export default class VoiceMails extends Mixins(BaseServiceMixin) {
  private voiceMails: VoiceMailModel[] = [];
  private loading = false;

  private twilioService!: TwilioService;
  private voiceMailFilter = new VoiceMailFilter();

  private get loadMore() {
    return (
      this.voiceMails.length === this.voiceMailFilter.pageParameters.page * this.voiceMailFilter.pageParameters.pageSize
    );
  }

  public async created() {
    this.twilioService = new TwilioService(this.axiosInstance);
  }

  private async mounted() {
    await this.getVoiceMails();
  }

  private async getVoiceMails() {
    this.loading = true;
    try {
      const response: VoiceMailModel[] = await this.twilioService.getVoiceMails(this.voiceMailFilter);
      this.voiceMails = response;
    } catch (error) {
      if (error.name === Shared.noTwilioSetup) {
        this.voiceMails = [];
      }
    } finally {
      this.loading = false;
    }
  }

  /*
   * Handle pagination event
   */
  private async onPageChange() {
    this.voiceMailFilter.pageParameters.page++;
    this.getVoiceMails();
  }

  private async clearFilter() {
    const filter = this.voiceMailFilter;
    this.voiceMailFilter = {
      pageParameters: filter.pageParameters,
      startDate: null,
      endDate: null,
    };
    await this.getVoiceMails();
  }

  private async applyFilter() {
    this.voiceMailFilter.pageParameters.page = 1;
    await this.getVoiceMails();
  }
}
